import { createDeliveryClient } from '@kontent-ai/delivery-sdk';
import React, { createContext } from 'react';
import { buildUseContextHook } from '../helpers/utilities';
import constants from '../../constant';
export function DeliveryClientProvider({ children, usePreviewMode, environment, }) {
    const client = makeDeliveryClient(environment.environmentId, usePreviewMode);
    return (React.createElement(DeliveryClientContext.Provider, { value: [client, { environment, usePreviewMode }] }, children));
}
const DeliveryClientContext = createContext(null);
export const useDeliveryClient = buildUseContextHook(DeliveryClientContext, 'useDeliveryClient', 'DeliveryClientProvider');
const kenticoDefaults = {
    usePreviewMode: false,
    environment: {
        environmentId: constants.KENTICO_ENVIRONMENT_ID,
    },
};
// merges defaults with configuration provided by surrounding application
export const getKenticoConfigState = (kenticoConfig) => {
    return {
        usePreviewMode: kenticoConfig.usePreviewMode,
        environment: {
            environmentId: kenticoConfig.environment.environmentId || kenticoDefaults.environment.environmentId,
            isProduction: kenticoConfig.environment.environmentId ? kenticoConfig.environment.environmentId === kenticoDefaults.environment.environmentId : true
        }
    };
};
const makeDeliveryClient = (environmentId, usePreviewMode) => {
    const previewOpts = usePreviewMode
        ? {
            previewApiKey: constants.KENTICO_PREVIEW_KEY,
            defaultQueryConfig: {
                usePreviewMode: true,
            },
        }
        : {};
    return createDeliveryClient({
        environmentId,
        ...previewOpts,
    });
};
//# sourceMappingURL=deliveryClient.js.map